import script from "./VNode.vue?vue&type=script&lang=js"
export * from "./VNode.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__